import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.fulfillment')
  .factory('$fulfillment', fulfillmentObjectFactory);

/* @ngInject */
function fulfillmentObjectFactory($bringozFactory: $bringozFactory,
                                  FulfillmentAPI: BringozApi,
                                  Fulfillment_Pageable_DS: DataStoreConfig) {
  function $fulfillment(id: string) {
    return $bringozFactory(id, FulfillmentAPI, Fulfillment_Pageable_DS);
  }
  return $fulfillment;
}
